import { StatusFilterType } from "@pages/Dashboard/contexts/Filter.context";
import { useFiltersDrawerContext } from "@pages/Dashboard/contexts/FiltersDrawer.context";
import { useGanttDataContext } from "@pages/Dashboard/contexts/GanttData.context";
import { applyFiltersToEvents } from "@pages/Dashboard/utils/applyFilters";
import { useMemo } from "react";

export function useFilteredEventsCount() {
  const { drawerFilters } = useFiltersDrawerContext();

  const { rawData } = useGanttDataContext();

  const counts = useMemo(() => {
    const activeStatusFilters: StatusFilterType[] = drawerFilters.status?.length
      ? drawerFilters.status
      : [];

    let total = 0;
    let filtered = 0;

    if (rawData?.lanedEvents) {
      const allEvents: Sentinel.Timeline.Event[] = [];
      rawData.lanedEvents.forEach((lane) => {
        lane.groupedEvents.forEach((group) => {
          allEvents.push(...group.events);
        });
      });

      total += allEvents.length;
      const filteredEvents = applyFiltersToEvents(
        allEvents,
        activeStatusFilters,
        drawerFilters.channels
      );
      filtered += filteredEvents.length;
    }

    return { total, filtered };
  }, [rawData, drawerFilters.status, drawerFilters.channels]);

  return counts;
}
